var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.loading && _vm.selectedDate && _vm.opcionais.length > 0,
            expression: "!loading && selectedDate && opcionais.length > 0",
          },
        ],
        staticClass: "wrapper",
        style: _vm.styleWrapper,
      },
      [
        !_vm.mobileMode
          ? _c("div", { staticClass: "header-container" }, [
              _c(
                "div",
                { staticStyle: { width: "9%", "text-align": "center" } },
                [
                  _c("i", {
                    staticClass: "fa-solid fa-star",
                    staticStyle: { "font-size": "20px" },
                    style: { color: _vm.primaryColor },
                  }),
                ]
              ),
              _vm._v(" "),
              _vm._m(0),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.opcionais, function (opt, i) {
          return _c(
            "div",
            {
              key: opt.id,
              class: {
                option: !_vm.mobileMode,
                "option-mobile": _vm.mobileMode,
              },
              style: { border: i == 0 ? "none" : null },
            },
            [
              _c(
                "div",
                {
                  staticClass: "option-info",
                  style: { width: _vm.mobileMode ? "64%" : null },
                },
                [
                  _c("strong", [_vm._v(_vm._s(opt.nome))]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  opt.preco_original
                    ? _c("span", [
                        _vm._v(
                          "de " +
                            _vm._s(_vm.formatMoney(opt.preco_original)) +
                            " por"
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.formatMoney(opt.preco)))]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "option-quantity",
                  style: { width: _vm.mobileMode ? "25%" : null },
                },
                [
                  _c("i", {
                    staticClass: "fa-solid fa-minus",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.sub(opt)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "option-quantity-display" }, [
                    _c("strong", [
                      _vm._v(_vm._s(_vm.getCurrentQuantidade(opt))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fa-solid fa-plus",
                    staticStyle: { cursor: "pointer" },
                    on: {
                      click: function ($event) {
                        return _vm.add(opt)
                      },
                    },
                  }),
                ]
              ),
            ]
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      {
        staticStyle: {
          width: "90%",
          "font-size": "14px",
          "line-height": "18px",
        },
      },
      [
        _c("div", [_c("strong", [_vm._v("Melhore sua experiência")])]),
        _vm._v(" "),
        _c("span", [_vm._v("com nossos opcionais")]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }